import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { PRIZE_TRANSLATIONS } from '../HoldemMaxPrizeTable/PrizeRows/prizeData';

import styles from './PrizePool.scss';

interface TableHeadProps {
  placeAwards?: number[];
  placeAwardsMaxLength: number;
}

export const TableHead: React.FC<TableHeadProps> = ({ placeAwards = [], placeAwardsMaxLength }) => {
  if (placeAwards.length === 0) return null;

  const prizePlaces = PRIZE_TRANSLATIONS.slice(0, placeAwardsMaxLength);

  return (
    <thead className="prize-pool-table-head">
      <tr>
        {prizePlaces.map(({ key, translation }, index) => (
          <th className={classNames(styles[key], styles.gamePrizePlace)} key={index}>
            <div>
              <i className={styles.iconCup} />
              <Translation {...translation} />
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
};
